import React from 'react';
import classNames from 'classnames';
import { APP_SEMANTIC } from '@/constant/theme/colors.constant';

interface MetaChipProps {
  children: React.ReactNode;
  /** Render value in monospace font (good for IDs) */
  mono?: boolean;
  /** Optional leading dot colour class, e.g. `"bg-emerald-400"` */
  dotColor?: string;
  /** Extra Tailwind classes */
  className?: string;
}

/**
 * Neutral rounded-full badge used in page headers and info bars to surface
 * lightweight metadata (roles, IDs, names, statuses, …).
 */
export const MetaChip = ({
  children,
  mono = false,
  dotColor,
  className = '',
}: MetaChipProps) => (
  <span
    className={classNames(
      'inline-flex items-center gap-1 px-2 py-0.5 rounded-full',
      'text-[10px] font-semibold',
      APP_SEMANTIC.neutral.bg,
      APP_SEMANTIC.neutral.text,
      'border border-gray-200 dark:border-white/[0.08]',
      mono && 'font-mono',
      className,
    )}
  >
    {dotColor && (
      <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${dotColor}`} />
    )}
    {children}
  </span>
);
